// extracted by mini-css-extract-plugin
export default {"form_wrapper":"FormRegistration_form_wrapper__ChTcq","form_content":"FormRegistration_form_content__KifS5"};